import {yupParseErrors} from "@helpers/validate/validate";
import {Schema} from "yup";

export const validateFnBySchema = ({
                                       value,
                                       validateSchema
                                   }: {
    validateSchema: Schema,
    value: unknown
}): {
    error: boolean,
    validate: boolean,
    errorMessage: Record<string, any>
} => {


    try {
        const validate = validateSchema?.validateSync(value, {abortEarly: false});
        return {
            validate: true,
            error: false,
            errorMessage: null
        }
    } catch (error) {
        if (error?.inner?.length && error.inner[0].path === '') {
            return {
                validate: false,
                error: true,
                errorMessage: error.inner[0].message || error.inner[0].errors?.join(',')
            }
        }
        return {
            validate: false,
            error: true,
            errorMessage: yupParseErrors(error)
        }
    }

}